import { toastr } from 'react-redux-toastr'
import branditRails from '../../../../api/brandit_rails'
import {
  setWarehousesAction,
  setWarehouseAction,
  setWarehousesStatusAction,
  setWarehousesErrorsAction,
  clearWarehousesErrorsAction
} from './warehouses.actions'

export const fetchWarehouses = () => async dispatch => {
  try {
    dispatch(setWarehousesStatusAction('loading'))
    dispatch(clearWarehousesErrorsAction())

    const { data } = await branditRails.get('/warehouses')

    // Convert array to object with id as key
    const warehousesById = data.reduce((acc, warehouse) => {
      acc[warehouse.id] = warehouse
      return acc
    }, {})

    dispatch(setWarehousesAction(warehousesById))
    dispatch(setWarehousesStatusAction('succeeded'))

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setWarehousesErrorsAction({ message: errorMessage }))
    dispatch(setWarehousesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const fetchWarehouse = id => async dispatch => {
  try {
    dispatch(setWarehousesStatusAction('loading'))
    dispatch(clearWarehousesErrorsAction())

    const { data } = await branditRails.get(`/warehouses/${id}`)

    dispatch(setWarehouseAction(data))
    dispatch(setWarehousesStatusAction('succeeded'))

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setWarehousesErrorsAction({ message: errorMessage }))
    dispatch(setWarehousesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const createWarehouse = formData => async dispatch => {
  try {
    dispatch(setWarehousesStatusAction('loading'))
    dispatch(clearWarehousesErrorsAction())

    const { data } = await branditRails.post('/warehouses', formData)

    dispatch(setWarehouseAction(data))
    dispatch(setWarehousesStatusAction('succeeded'))
    toastr.success('Success', 'Warehouse created successfully!')

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setWarehousesErrorsAction({ message: errorMessage }))
    dispatch(setWarehousesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const editWarehouse = (id, formData) => async dispatch => {
  try {
    dispatch(setWarehousesStatusAction('loading'))
    dispatch(clearWarehousesErrorsAction())

    const { data } = await branditRails.patch(`/warehouses/${id}`, formData)

    dispatch(setWarehouseAction(data))
    dispatch(setWarehousesStatusAction('succeeded'))
    toastr.success('Success', 'Warehouse updated successfully!')

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setWarehousesErrorsAction({ message: errorMessage }))
    dispatch(setWarehousesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const deleteWarehouse = id => async dispatch => {
  try {
    dispatch(setWarehousesStatusAction('loading'))
    dispatch(clearWarehousesErrorsAction())

    await branditRails.delete(`/warehouses/${id}`)

    // Refresh warehouses after deletion
    await dispatch(fetchWarehouses())

    dispatch(setWarehousesStatusAction('succeeded'))
    toastr.success('Success', 'Warehouse deleted successfully!')
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setWarehousesErrorsAction({ message: errorMessage }))
    dispatch(setWarehousesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}
